import { useMutation } from "react-query";
import { customApi } from "../../../../../CustomHoock/CustomApi";

export const useGetCustomerOrderDesignHistoryChart = () => {
  return useMutation(["GetCustomerOrderDesignHistoryChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetCustomerOrderDesignHistoryChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};
export const useGetCustomerAverageOrderDesignHistoryChart = () => {
  return useMutation(["GetCustomerAverageOrderDesignHistoryChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetCustomerAverageOrderDesignHistoryChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};
